<template>
  <div v-if="tableMetadata" class="table-container">
    <!-- Add prose classes here -->
    <div :class="[
      'prose max-w-none overflow-x-auto rounded-lg border border-nera-border shadow-sm',
      // Tables — auto layout sizes columns to content; wrapper handles overflow
      'prose-table:w-full prose-table:table-auto',
      'prose-table:mt-0 prose-table:mb-0 prose-table:border-0',

      // Table headers — solid brand-blue header (admin-style accent)
      'prose-thead:bg-nera-accent',
      'prose-th:text-nera-text-light prose-th:bg-nera-accent-light prose-th:font-semibold prose-th:text-left prose-th:text-base!',
      'prose-th:py-2.5! prose-th:px-4 prose-th:first:!pl-4 prose-th:last:!pr-4',
      'prose-th:whitespace-nowrap',

      // Table cells
      'prose-td:py-1.5! prose-td:border-b prose-td:text-base',
      'prose-td:border-nera-border prose-td:text-nera-text',
      'prose-td:px-4 prose-td:first:!pl-4 prose-td:last:!pr-4',
      'prose-td:whitespace-nowrap',

      // Table body — light bg with zebra stripes
      'prose-tbody:bg-white',
      'prose-tr:transition-colors',
      'prose-tr:odd:bg-nera-elevated-2',
    ]" v-html="renderedTable"></div>
    <div class="download-section my-3">
      <a v-if="tableMetadata.download_url" :href="`/api/csv_tables/${tableMetadata.download_url}`" download
        class="!no-underline inline-flex items-center gap-2 px-3 py-1.5 rounded-md text-nera-accent transition-all hover:!bg-nera-light-hover hover:!text-nera-accent-hover">
        <i class="fas fa-download text-xs"></i>
        Download Full Table ({{ tableMetadata.total_rows }}
        {{ Number(tableMetadata.total_rows) === 1 ? "row" : "rows" }})
      </a>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { marked } from "marked";

const props = defineProps({
  tableId: {
    type: String,
    required: true,
  },
  tables: {
    type: Array,
    required: true,
  },
});

const downloadTable = computed(() => {
  const isTruncated =
    tableMetadata.value && tableMetadata.value.total_rows > 10;
  const label = isTruncated ? `Download Full Table` : `Download Table`;
  const rowCountBadge = isTruncated
    ? ` (${tableMetadata.value.total_rows} rows)`
    : "";
  return label + rowCountBadge;
});

// Find the table metadata by ID
const tableMetadata = computed(() => {
  return props.tables.find((t) => {
    const tId = t.id.toString().replace(/[^0-9]/g, "");
    const searchId = props.tableId.toString().replace(/[^0-9]/g, "");
    return t.id === props.tableId || tId === searchId;
  });
});

// Render the preview_data markdown to HTML
const renderedTable = computed(() => {
  if (!tableMetadata.value?.preview_data) return "";
  return marked(tableMetadata.value.preview_data);
});

// Full download URL
// const downloadUrl = computed(() => {
//   if (!tableMetadata.value?.download_url) return null
//   const baseUrl = ""
// })
</script>
